import { type ContextData } from '@common/defaults/ContextData';

export const getAssetsPrefix = (contextData: ContextData | undefined): string => {
    let assetsPrefix = process.env['NEXT_PUBLIC_ASSET_PREFIX'];

    if (contextData?.hostname.match(/admin/)) {
        const schema = contextData.hostname.match(/local/) ? 'http' : 'https';
        assetsPrefix = `${schema}://${contextData.context.url}`;
    }

    return assetsPrefix || '';
};
